import { render, staticRenderFns } from "./PolicyReissueStartDialog.vue?vue&type=template&id=f0d7d2fa&scoped=true&"
import script from "./PolicyReissueStartDialog.vue?vue&type=script&lang=js&"
export * from "./PolicyReissueStartDialog.vue?vue&type=script&lang=js&"
import style0 from "./PolicyReissueStartDialog.vue?vue&type=style&index=0&id=f0d7d2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d7d2fa",
  null
  
)

export default component.exports